import apiClient from "./apiClient";

export const UrlReview = {
    getUrl: async (body) => {
        const response = await apiClient.post("/api/Reviews/PostUrlServiceMap", body);
        return response.data;
    }
}